// src/pages/admin/AdminRolesManager.jsx
import { useEffect, useState } from "react";
import axios from "axios";
import Banner from "../../components/Banner";

export default function AdminRolesManager() {
  const [roles, setRoles] = useState({});
  const [allPermissions, setAllPermissions] = useState([]);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => {
        setSuccess("");
        setError("");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [success, error]);

  useEffect(() => {
    const fetchRolesAndPermissions = async () => {
      try {
        const [rolesRes, permsRes] = await Promise.all([
          axios.get(`${BASE_URL}/api/admin-roles`, { withCredentials: true }),
          axios.get(`${BASE_URL}/api/admin-roles/permissions`, { withCredentials: true }),
        ]);

        const rolesData = {};
        rolesRes.data.forEach((role) => {
          rolesData[role.name] = {
            label: role.name,
            permissions: role.permissions || [],
          };
        });

        setRoles(rolesData);
        setAllPermissions(permsRes.data || []);
      } catch (err) {
        console.error("Failed to fetch roles or permissions", err);
      }
    };

    fetchRolesAndPermissions();
  }, [BASE_URL]);

  const handleToggle = (roleKey, permission) => {
    setRoles((prev) => {
      const currentPermissions = prev[roleKey].permissions;
      const updatedPermissions = currentPermissions.includes(permission)
        ? currentPermissions.filter((p) => p !== permission)
        : [...currentPermissions, permission];

      return {
        ...prev,
        [roleKey]: {
          ...prev[roleKey],
          permissions: updatedPermissions,
        },
      };
    });
  };

const handleSave = async () => {
  const payload = Object.keys(roles).map((roleKey) => ({
    name: roleKey,
    permissions: roles[roleKey].permissions,
  }));

  try {
    await axios.put(`${BASE_URL}/api/admin-roles`, payload, { withCredentials: true });
    setSuccess("Roles updated successfully");
  } catch (err) {
    console.error("Failed to save roles:", err);
    setError("Failed to save changes");
  }
};


  return (
    <div>
      <Banner type="success" message={success} />
      <Banner type="error" message={error} />
      <div className="max-w-4xl mx-auto bg-white p-6 rounded shadow">
        <h1 className="text-2xl font-bold mb-6">Roles & Permissions</h1>

        {Object.keys(roles).map((roleKey) => (
          <div key={roleKey} className="mb-6 border-b pb-4">
            <h2 className="text-lg font-semibold mb-2 capitalize">{roles[roleKey].label}</h2>

            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
              {allPermissions.map((perm) => (
                <label key={perm} className="flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={roles[roleKey].permissions.includes(perm)}
                    onChange={() => handleToggle(roleKey, perm)}
                    className="w-5 h-5 text-blue-600 bg-white border-2 border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:outline-none"
                  />
                  <span className="text-sm">{perm}</span>
                </label>
              ))}
            </div>
          </div>
        ))}

        <button
          onClick={handleSave}
          className="mt-4 bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-500"
        >
          Save Changes
        </button>
      </div>
    </div>
  );
}
